var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "drawer-wrapper"
  }, [_c('CustomerContactSidebar'), _c('div', {
    staticClass: "customer-contact-wrap"
  }, [_c('div', {
    staticClass: "customer-contact-detail"
  }, [_c('CustomerContactInfo')], 1)]), _c('router-view', {
    staticClass: "content"
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }